export default {
    delete_unittype_title: "Delete Unit Types",
    delete_unittype_success_message: "The unit type has been deleted",
    delete_unittype_error_message: "It was not possible to delete the unit type",
    delete_unittype_label: "Are you sure you want to delete the unit type?",
    delete_unittype_in_use: "The unit type is linked to some device models, so it is not possible to remove it"
}